type ErrorContext = Record<string, string | number | boolean | object | undefined>;
export class CustomErrorForSentry extends Error {
  message: string;
  code?: string;
  nextSteps?: string;
  context?: ErrorContext;
  error?: unknown;

  constructor({
    message,
    code,
    nextSteps,
    context,
    error,
  }: {
    message: string;
    code?: string;
    nextSteps?: string;
    context?: ErrorContext;
    error?: unknown;
  }) {
    super(message);
    this.message = message;
    this.code = code;
    this.nextSteps = nextSteps;
    this.context = context;
    this.error = error;
  }

  withContext(context: ErrorContext) {
    this.context = context;
    return this;
  }

  withCode(code: string) {
    this.code = code;
    return this;
  }

  withNextSteps(nextSteps: string) {
    this.nextSteps = nextSteps;
    return this;
  }

  withError(error: unknown) {
    this.error = error;
    return this;
  }
}
